import {useDispatch} from "react-redux";
import {
    setBAC,
    setBrand,
    setDealerFlag,
    setServer
} from "../../core/redux/ActionCreator";
import dealerLocatorService from "../services/dealerLocatorService";

export const Params = () => {
    const dispatch = useDispatch();
    //console.log(window.document.URL);
    //console.log(window.document.referrer);

    if (window.document.referrer) {
        dispatch(setServer(window.document.referrer + 'tire-finder'));
    } else {
        dispatch(setServer(window.location.origin + '/tirefinder'));
    }

    const queryParams = new URLSearchParams(window.location.search);
    const src = queryParams.get('src');
    const bac = queryParams.toString().includes('bac');

    if(bac){
        let dealerBAC = (queryParams.get('bac') || queryParams.get("baccode") || queryParams.get("bacId"));
        if (dealerBAC === null) {
            let bacString = queryParams.toString().split('bac=');
            dispatch(setBAC(bacString[1]));
            dispatch(setDealerFlag(true));
            dealerLocatorService.getDealerByBAC(bacString[1]);
        } else if (dealerBAC.match(/^[0-9]+$/)) {
            dispatch(setBAC(dealerBAC));
            dispatch(setDealerFlag(true));
            dealerLocatorService.getDealerByBAC(dealerBAC);
        } else {
            console.log('Invalid bac parameter: bac=' + dealerBAC);
            dispatch(setBAC(999999));
            dispatch(setDealerFlag(false));
        }
    } else {
        dispatch(setBAC(999999));
        dispatch(setDealerFlag(false));
    }
    dispatch(setBrand(src));
};

export default Params;